// 先從 compareDataList 產生 campaign 和 plan 的對應資料
// 因為有的資料只有在 ui 需要用到, 不想要這樣子去污染到 store 的資料
// 再用資料去產生對應的 ui 組件
import { exportDataForSpeed, exportDataForDirect } from '@/utils/dataConvert'

export default class PlanManager {
  constructor () {
    this.compareUnitDataList = []
    this.planDataList = []
    this.removeCompareData = () => {}
  }
  resetData (compareDataList, removeCompareData) {
    // 將 compareData 附加 UI 呈現需要的資料
    this.compareUnitDataList = compareDataList.map((compareData, index) => {
      return { index, compareData, planIndex: -1 }
    })

    // 從 campaignData 轉預設的 planData
    this.planDataList = this.compareUnitDataList.map((compareUnitData, index) => {
      compareUnitData.planIndex = index
      return {
        planName: compareUnitData.compareData.resultName,
        compareUnitDataList: [compareUnitData],
        merged: false,
        checked: true
      }
    })

    this.removeCompareData = removeCompareData
  }
  choosePlan (index, checked) {
    this.planDataList[index].checked = checked
  }
  rearrangePlanList () {
    // @Zone update planId with current planDataList
    this.planDataList.map((plan, planIndex) => {
      if (plan.planName === '') {
        plan.planName = `計算結果 ${planIndex}`
      }
      plan.compareUnitDataList.map(compareUnitData => {
        compareUnitData.planIndex = planIndex
      })
    })
  }
  mergeCompareData (chosenCompareUnitDataArr, newPlanName) {
    // @Zone find out the plans that contain merged data
    let newPlan
    const planIndexsThatNeedBeRemovedArr = []
    this.planDataList.map((planData, i) => {
      chosenCompareUnitDataArr.map((compareUnitData) => {
        const tmpIndex = planData.compareUnitDataList.indexOf(compareUnitData)
        if (tmpIndex > -1) {
          if (newPlan === undefined) {
            newPlan = {
              planName: newPlanName || planData.planName,
              compareUnitDataList: chosenCompareUnitDataArr,
              merged: true,
              checked: planData.checked
            }
          }

          planData.compareUnitDataList.splice(tmpIndex, 1)
          if (planData.compareUnitDataList.length === 0) {
            planIndexsThatNeedBeRemovedArr.push(i)
          }
        }
      })
    })

    planIndexsThatNeedBeRemovedArr.sort((a, b) => b - a)
    planIndexsThatNeedBeRemovedArr.map(index => {
      this.planDataList.splice(index, 1)
    })

    this.planDataList.unshift(newPlan)
    this.rearrangePlanList()
  }
  cancelMerge (index) {
    const removedPlan = this.planDataList.splice(index, 1)[0]
    const newPlans = removedPlan.compareUnitDataList.map(compareUnitData => {
      return {
        // 合併前的項目名
        planName: compareUnitData.compareData.resultName,
        compareUnitDataList: [compareUnitData],
        merged: false,
        checked: removedPlan.checked
      }
    })
    this.planDataList.splice(index, 0, ...newPlans)
    this.rearrangePlanList()
  }
  renamePlan (index, name) {
    this.planDataList[index].planName = name
  }
  deletePlan (index) {
    const deletedPlan = this.planDataList.splice(index, 1)[0]
    if (deletedPlan) {
      deletedPlan.compareUnitDataList.map(chosenCompareUnitData => {
        this.removeCompareData(chosenCompareUnitData.index)
      })
    }
    this.rearrangePlanList()
  }
  batchTogglePlans (val) {
    this.planDataList.map(plan => {
      plan.checked = val
    })
  }
  getCompareUnitDataThatCanBeMerged () {
    const result = []
    this.planDataList.filter(plan => !plan.merged).map(plan => {
      result.push(...plan.compareUnitDataList)
    })
    return result
  }
  getSelectedPlanDataList () {
    return this.planDataList.filter(plan => plan.checked)
  }
  getQpSimulationReportArr (options, planDataList, isInsider) {
    const convertMethodOption = { speed: exportDataForSpeed, direct: exportDataForDirect }
    return planDataList.reduce((result, plan) => {
      let tmpSimulationReport = {}
      // @Zone assume that there won't be more than 1 speed and direct
      plan.compareUnitDataList.map(({ compareData }) => {
        // 是合併項目就用合併項目名，不是的話就用原本的名字
        tmpSimulationReport[compareData.type] = convertMethodOption[compareData.type](options[compareData.type], [compareData], isInsider, plan.merged ? plan.planName : null)[0]
      })

      // @Zone add empty data
      if (tmpSimulationReport.speed === undefined) {
        tmpSimulationReport.speed = {
          basic_info: {},
          sim_result: {},
          condition: {}
        }
      }
      if (tmpSimulationReport.direct === undefined) {
        tmpSimulationReport.direct = {
          basic_info: {},
          sim_result: {},
          condition: {},
          budgets: [],
          result_by_media: []
        }
      }

      result.push(tmpSimulationReport)
      return result
    }, [])
  }
  checkIfAllSelected () {
    return this.getSelectedPlanDataList().length === this.planDataList.length
  }
}
